import { getPersistedFilterKey } from "modules/common/hooks/usePersistedFilters";
import { AMOUNT_FILTER_KEYS } from "modules/common/types/filters";
import { createAmountFilterSchema } from "modules/common/utils/amountFilterSchema";
import { getLastWeekDateRange } from "modules/common/utils/getLastWeekDateRange";
import { object } from "utils/yup";

export const FILTERS_KEYS = {
  ...AMOUNT_FILTER_KEYS,
  CURRENCY: "currency",
  COUNTRIES: "country",
  BANK: "bank",
  END_DATE: "endDate",
  LICENCE: "licence",
  START_DATE: "startDate",
  STATUS: "status",
  NO_BANK_CHOSEN: "noBankChosen",
} as const;

export const FILTERS_SCHEMA = object().shape({
  ...createAmountFilterSchema(),
});

function getDateRange() {
  const { start, end } = getLastWeekDateRange();

  return { startDate: start.toISODate(), endDate: end.toISODate() };
}

export function getDefaultFilters() {
  const { startDate, endDate } = getDateRange();

  return {
    [FILTERS_KEYS.LICENCE]: [],
    [FILTERS_KEYS.STATUS]: [],
    [FILTERS_KEYS.CURRENCY]: [],
    [FILTERS_KEYS.BANK]: [],
    [FILTERS_KEYS.COUNTRIES]: [],
    [FILTERS_KEYS.AMOUNT_FROM]: null,
    [FILTERS_KEYS.AMOUNT_TO]: null,
    [FILTERS_KEYS.START_DATE]: startDate,
    [FILTERS_KEYS.END_DATE]: endDate,
    [FILTERS_KEYS.NO_BANK_CHOSEN]: false,
  };
}

const { startDate: initialStartDate, endDate: initialEndDate } = getDateRange();

export const INITIAL_FILTERS = {
  [FILTERS_KEYS.LICENCE]: [],
  [FILTERS_KEYS.STATUS]: [],
  [FILTERS_KEYS.CURRENCY]: [],
  [FILTERS_KEYS.BANK]: [],
  [FILTERS_KEYS.COUNTRIES]: [],
  [FILTERS_KEYS.AMOUNT_FROM]: null,
  [FILTERS_KEYS.AMOUNT_TO]: null,
  [FILTERS_KEYS.START_DATE]: initialStartDate,
  [FILTERS_KEYS.END_DATE]: initialEndDate,
  [FILTERS_KEYS.NO_BANK_CHOSEN]: false,
};

export const DEFAULT_FILTERS_CONFIGURATION = {
  [FILTERS_KEYS.LICENCE]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.STATUS]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.CURRENCY]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.BANK]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.COUNTRIES]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.START_DATE]: {
    array: undefined,
    defaultValue: null,
  },
  [FILTERS_KEYS.END_DATE]: {
    array: undefined,
    defaultValue: null,
  },
  [FILTERS_KEYS.NO_BANK_CHOSEN]: {
    array: undefined,
    defaultValue: false,
  },
  [FILTERS_KEYS.AMOUNT_FROM]: {
    array: undefined,
    defaultValue: null,
  },
  [FILTERS_KEYS.AMOUNT_TO]: {
    array: undefined,
    defaultValue: null,
  },
};

export const INITIAL_FILTERS_CONFIGURATION = {
  ...DEFAULT_FILTERS_CONFIGURATION,
  [FILTERS_KEYS.START_DATE]: {
    array: undefined,
    defaultValue: initialStartDate,
  },
  [FILTERS_KEYS.END_DATE]: {
    array: undefined,
    defaultValue: initialEndDate,
  },
};

export const FILTERS_PERSISTED_KEY = getPersistedFilterKey("new.payments");

export const DEFAULT_FILTERS = getDefaultFilters();
